module.exports = __webpack_public_path__ + "img/offBlog.e8094779.png";